module.exports = __webpack_public_path__ + "static/media/7.076af6a6.JPG";